import React, { useEffect, useState } from "react";
import TimeSlotSelector from 'components/shared/TimeSlotSelector/TimeSlotSelector';
import './Faq.scss';

export const Faq = () => {
    let slotsData=[
        {
            "startDateTime": "2025-03-12T12:00:00Z",
        "endDateTime": "2025-03-12T13:00:00Z",
        "isExpertSlot": true
},
        {
            "startDateTime": "2025-03-13T22:00:00Z",
        "endDateTime": "2025-03-14T00:00:00Z",
        "isExpertSlot": true
}
]
    return (
        <div className="faq__wrap">
            <div className="timeselector__wrap">
            <TimeSlotSelector />
            </div>
        </div>
    )
}